const collectorFrameThemes = [
  {
    id: 'frame-starry-moon',
    label: 'Starry Moon',
    base: '#FFB500',
    darker: '#6a4c00'
  },
  {
    id: 'frame-dancing',
    label: 'Dancing on the Grass',
    base: '#FF7900',
    darker: '#6a3300'
  },
  {
    id: 'frame-fountain',
    label: 'Fountain of Delights',
    base: '#FF3B58',
    darker: '#6a1925'
  },
  {
    id: 'frame-swinging',
    label: 'Swinging Dress',
    base: '#FF0097',
    darker: '#6a003f'
  },
  {
    id: 'frame-water-lily',
    label: 'Water Lily Pond',
    base: '#D000C5',
    darker: '#570053'
  },
];

export function getCollectorFrameTheme(themeId) {
  if (!themeId) return null;
  return collectorFrameThemes.find((theme) => theme.id === themeId) || null;
}

export default collectorFrameThemes;
